/**
 * Tracking status (used by KenobiService)
 */
export enum Status {
    OK = '**OK',
    KOSI = 'KOSI',
    KORG = 'KORG',
}
